import { Spinner } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import {
  CmButton,
  CmCheckBox,
  CmModal,
  CmModalBody,
  CmModalFooter,
  CmStack,
  CmText,
} from '@/components/uiParts';
import { SearchItem } from '@/pages/menu-managements/services/searchItem';
type Props = {
  title: string;
  emptyMessage: string;
  isLoading: boolean;
  isOpen: boolean;
  onClose: () => void;
  selectedItems: SearchItem[];
  searchItems: SearchItem[];
  handleSetMultipleItems: (items: SearchItem[]) => void;
};
export const SearchItemSelectModal: React.FC<Props> = (props) => {
  const [selectedItems, setSelectedItems] = useState<SearchItem[]>(
    props.selectedItems
  );

  useEffect(() => {
    if (props.isOpen) {
      setSelectedItems(props.selectedItems);
    }
  }, [props.isOpen, props.selectedItems]);

  const onClickApply = () => {
    props.handleSetMultipleItems(selectedItems);
    props.onClose();
  };

  const selectedItemById = Object.fromEntries(
    selectedItems.map((e) => [e.id, e])
  );

  const hasSearchItems = props.searchItems.length > 0;

  return (
    <CmModal
      size="4xl"
      title={props.title}
      isOpen={props.isOpen}
      onClose={props.onClose}
    >
      <CmModalBody>
        <CmStack>
          {props.isLoading ? (
            <CmStack alignItems="center">
              <Spinner />
            </CmStack>
          ) : hasSearchItems ? (
            props.searchItems.map((item) => (
              <CmCheckBox
                key={item.id}
                value={item.id}
                isChecked={Boolean(selectedItemById[item.id])}
                onChange={(e) => {
                  setSelectedItems((items) => {
                    if (e.target.checked) {
                      return [...items, item];
                    } else {
                      return items.filter((e) => e.id !== item.id);
                    }
                  });
                }}
              >
                {item.title.translation.ja}
              </CmCheckBox>
            ))
          ) : (
            <CmText>{props.emptyMessage}</CmText>
          )}
        </CmStack>
      </CmModalBody>
      <CmModalFooter>
        <CmButton onClick={onClickApply}>設定する</CmButton>
      </CmModalFooter>
    </CmModal>
  );
};
